<template>
	<section class="download-section" :aria-label="t(`${I18N_NS}.download.ariaLabel`)">
		<div class="download-section__bg" aria-hidden="true"></div>
		<div class="download-section__inner">
			<div class="download-section__content">
				<h2 class="download-section__title">{{ t(`${I18N_NS}.download.title`) }}</h2>
				<p class="download-section__desc">{{ t(`${I18N_NS}.download.desc`) }}</p>
			</div>

			<div class="download-section__actions">
				<a
					href="javascript:void(0)"
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.googlePlayAria`)"
					@click="emit('android-click')"
				>
					<img
						class="download-section__button-icon"
						src="../../../pc/components/download-section/images/google-play.png"
						alt=""
					/>
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.storeLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.googlePlayName`)
						}}</span>
					</span>
				</a>
				<a
					href="javascript:void(0)"
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.appStoreAria`)"
					@click="emit('ios-click')"
				>
					<img
						class="download-section__button-icon"
						src="../../../pc/components/download-section/images/app-store.png"
						alt=""
					/>
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.storeLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.appStoreName`)
						}}</span>
					</span>
				</a>
				<a
					:href="apkLink"
					download
					class="download-section__button"
					:aria-label="t(`${I18N_NS}.download.apkAria`)"
					@click="emit('direct-download')"
				>
					<img
						class="download-section__button-icon"
						src="../../../pc/components/download-section/images/android.png"
						alt=""
					/>
					<span class="download-section__button-text">
						<span class="download-section__button-label">{{
							t(`${I18N_NS}.download.apkLabel`)
						}}</span>
						<span class="download-section__button-name">{{
							t(`${I18N_NS}.download.apkName`)
						}}</span>
					</span>
				</a>
			</div>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from "~/composables/useI18n";

const I18N_NS = "aboutUs";
const { t } = useI18n();

defineProps({
	apkLink: {
		type: String,
		default: "",
	},
});

const emit = defineEmits(["android-click", "ios-click", "direct-download"]);
</script>

<style lang="scss" scoped>
.download-section {
	position: relative;
	box-sizing: border-box;
	width: 100%;

	&__bg {
		position: absolute;
		inset: 0;
		width: 100%;
		background: linear-gradient(90deg, #fffcf6 0%, #fff1cb 91.34%);
		z-index: 0;
	}

	&__inner {
		position: relative;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 30px 32px;
	}

	&__content {
		width: 100%;
		margin-bottom: 20px;
		text-align: center;
	}

	&__title {
		margin: 0 0 8px;
		color: #333333;
		font-size: 28px;
		font-weight: 700;
		line-height: 40px;
	}

	&__desc {
		margin: 0;
		color: rgba(51, 51, 51, 0.45);
		font-size: 22px;
		line-height: 30px;
	}

	&__actions {
		display: flex;
		align-items: stretch;
		justify-content: center;
		width: 100%;
		gap: 20px;
	}

	&__button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 0;
		height: 76px;
		padding: 0 14px;
		border-radius: 8px;
		background: #262626;
		color: #ffffff;
		text-decoration: none;
		box-sizing: border-box;
	}

	&__button-icon {
		width: 42px;
		height: 42px;
		flex-shrink: 0;
		object-fit: contain;
	}

	&__button-text {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-left: 14px;
		min-width: 0;
	}

	&__button-label {
		font-size: 14px;
		font-weight: 400;
		line-height: 26px;
		white-space: nowrap;
	}

	&__button-name {
		font-size: 18px;
		font-weight: 600;
		line-height: 26px;
		white-space: nowrap;
	}
}
</style>
